import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import VuetifyToast from "vuetify-toast-snackbar";

Vue.use(Vuetify);

const vueObj = new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#8BAA0E", //teal
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#b71c1c",
      },
      dark: {
        primary: "#8BAA0E",
      },
    },
  },
  icons: {
     iconfont: 'mdiSvg', // default - only for display purposes
   },
});

export default vueObj;


const optsToast = [
  {
    x: "right", // default
    y: "bottom", // default
    color: "info", // default
    icon: "info",
    iconColor: "", // default
    classes: ["body-2"],
    timeout: 3500, // default
    dismissable: true, // default
    multiLine: false, // default
    vertical: false, // default
    queueable: true, // default
    showClose: false, // default
    closeText: "", // default
    closeIcon: "close", // default
    closeColor: "", // default
    slot: [], // default
    shorts: {
      custom: {
        color: "purple",
      },
    },
    property: "$toast", // default
  },
];

Vue.use(VuetifyToast, { $vuetify: vueObj.framework }, optsToast);